import { Col, DatePicker, Form, FormInstance, Row } from "antd";
import dayjs from "dayjs";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
interface Props {
  form: FormInstance;
}
const SubjectAncLmpDeliveryDate: React.FC<Props> = (props) => {
  const { form } = props;
  const { t } = useTranslation();
  const lmpDate = Form.useWatch(["subjectAnc", "lmpDate"], form);
  return (
    <Row>
      <Col span={24}>{t("exp_delivery_date")}</Col>
      <Col span={24} style={{ marginTop: "10px" }}>
        <b>
          {lmpDate
            ? dayjs(lmpDate)
                .add(9, "month")
                .add(7, "day")
                .format("DD-MMM-YYYY")
            : "-"}
        </b>
      </Col>
      <Form.Item name={["subjectAnc", "id"]} hidden />
    </Row>
  );
};

export default SubjectAncLmpDeliveryDate;
